import { useState } from "react";
import Form from "./Form";
import { Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import Spacer from "./Spacer";

const fields = [
  {
    id: "name",
    name: "Your Name",
    type: "text",
    required: true,
  },
  {
    id: "email",
    name: "Email",
    type: "email",
    required: true,
  },
  {
    id: "password",
    name: "Password",
    type: "password",
    required: true,
  },
  {
    id: "family_name",
    name: "Family Name",
    type: "text",
    required: true,
  },
];

export default function Signup() {
  const [success, setSuccess] = useState(false);

  function handleSuccess() {
    setSuccess(true);
  }

  if (success) {
    return (
      <AuthLayout
        heading="Sign Up"
        message="Signup successful! Please check your email to confirm your address."
      ></AuthLayout>
    );
  }

  return (
    <AuthLayout heading="Sign up for an account">
      <Form
        path="signup"
        fields={fields}
        submitCallback={handleSuccess}
        updateCache={false}
        submitText="Sign Up"
      />
      <Spacer size="large" />
      <Link to="/login" className="hover:underline text-sm text-center block">
        Already have an account? Login
      </Link>
    </AuthLayout>
  );
}
